import './App.css';
import Home from './Components/Pages/Home';
function App() {
  return (
  <div>
    <Home/>
  </div>
  );
}

export default App;
